import { Service } from '@/request/http.js'

// 酒店列表
export function hotelList (data) {
  return Service({
    url: '/api/hotelList',
    method: 'post',
    params: data
  })
}

// 酒店详情
export function hotelDetail (data) {
  return Service({
    url: '/api/hotelDetail',
    method: 'post',
    params: data
  })
}

// 酒店图片
export function hotelImg (data) {
  return Service({
    url: '/api/hotelDetail',
    method: 'post',
    params: data
  })
}

// 酒店价格
export function hotelQuotedprice (data) {
  return Service({
    url: '/api/hotelDetail',
    method: 'post',
    params: data
  })
}

// 酒店政策
export function hotelPolicy (data) {
  return Service({
    url: '/api/hotelDetail',
    method: 'post',
    params: data
  })
}

// 酒店推荐
export function recommendHotel (data) {
  return Service({
    url: '/api/hotelDetail',
    method: 'post',
    params: data
  })
}

// 酒店设备
export function hotelFacilities (data) {
  return Service({
    url: '/api/hotelDetail',
    method: 'post',
    params: data
  })
}

// 酒店设备
export function getCityId (data) {
  return Service({
    url: '/api/hotelDetail',
    method: 'post',
    params: data
  })
}

// 酒店列表-获取搜索链接的当地时间
export function getTimeZone (data) {
  return Service({
    url: '/api/getTimeZone',
    method: 'post',
    params: data
  })
}

// 获取主搜索国籍
export function getCountry (data) {
  return Service({
    url: '/api/getCountry',
    method: 'post',
    params: data
  })
}

// 新酒店政策
export function hotelPolicyNew (data) {
  return Service({
    url: '/api/hotelDetail',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/hotel.js